module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-3.jpg?f19089374587ee4b3db1f504a363b09d";